<template>
    <div id="user-info-base">
        <a-form class="form" :form="form" @submit="handleSubmit">
            <a-form-item label="用户账号：" :label-col="{ span: 4}" :wrapper-col="{ span: 12 }">
                <a-input
                    disabled
                    v-decorator="['account']"
                />
            </a-form-item>
            <a-form-item label="绑定手机号：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
                <a-input
                    disabled
                    v-decorator="['phone']"
                />
            </a-form-item>
            <a-form-item label="姓名：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
                <a-input
                    v-decorator="['name', { rules: [{ required: true, message: '请输入你的用户名!' }] }]"
                />
            </a-form-item>
            <a-form-item label="性别：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
                <a-radio-group 
                    name="radioGroup"
                    v-decorator="['sex']"
                >
                    <a-radio :value="1">男</a-radio>
                    <a-radio :value="2">女</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="单位名称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
                <a-input
                    v-decorator="['organizationName', { rules: [{ required: true, message: '请输入你的单位名称!' }] }]"
                />
            </a-form-item>
            <a-form-item label="职务：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
                <a-input
                    v-decorator="['post', { rules: [{ required: true, message: '请输入你的单位名称!' }] }]"
                />
            </a-form-item>
            <a-form-item
                :wrapper-col="{ span: 12, offset: 5 }"
            >
                <a-button
                    type="primary"
                    html-type="submit"
                >
                    保存
                </a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
export default {
    name:"UserInfoBase",
    data () {
        return {
            userDataCopy:null,
            form: this.$form.createForm(this),
        };
    },
    props:{
        userData: Object
    },
    created(){
        this.userDataCopy = JSON.parse(JSON.stringify(this.userData));
        
    },
    mounted(){
        this.form.setFieldsValue(
            {
                name: this.userDataCopy.userInfo.name,
                account: this.userDataCopy.userInfo.account,
                sex: this.userDataCopy.userInfo.sex,
                organizationName: this.userDataCopy.userInfo.organizationName,
                post: this.userDataCopy.userInfo.post,
                phone: this.userDataCopy.phone,
            }
        );
    },
    methods: {
        handleSubmit(e){
           e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.saveUserInfo(values);
                }
            });
            return
       },
       saveUserInfo(values){
           let url = UrlApi.updateUserInfo;
           let userId = this.$store.getters.getUserId;
           let token = this.$store.getters.getToken;
           let params = `userId=${userId}&name=${values.name}&organizationName=${values.organizationName}&sex=${values.sex}&post=${values.post}`;
           this.$http.post(url,params,{
               headers:{
                   "Authorization":token
               }
           }).then((res)=>{
               let {message,success} = res.data;
               if(success){
                   this.$message.success(message);
                   this.$emit("getData")
                   return
               }
               this.$message.error(message);
           })
           
       }
    }
}

</script>
<style lang="less" scoped>
    #user-info-base {
        margin-left: 0px;
    }
</style>